import { useSelector } from "react-redux";
import { Select2V2 } from "@components/FormsV2";
import { RootState } from "@reducers/rootReducer";
import {
  useListCurrencysForAccountQuery,
  useListRateTablesForAccountQuery,
} from "@generated";
import {
  ACCOUNT_DEFAULT_VALUE,
  buildPreferenceOptions,
  NamedRecord,
} from "./preferenceOptions";

interface Props {
  rateTableId: string | null;
  currencyId: string | null;
  // The user's current selections, so an archived one still shows by name.
  currentRateTable?: NamedRecord | null;
  currentCurrency?: NamedRecord | null;
  onRateTableChange: (id: string | null) => void;
  onCurrencyChange: (id: string | null) => void;
}

const toRecords = (data?: { id?: string | number; attributes?: any }[]) =>
  (data || []).map((r) => ({
    id: String(r.id),
    name: String(r.attributes?.name ?? ""),
  }));

const PreferredDefaultsFields = ({
  rateTableId,
  currencyId,
  currentRateTable,
  currentCurrency,
  onRateTableChange,
  onCurrencyChange,
}: Props) => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);
  const { data: rateTables } = useListRateTablesForAccountQuery(
    { slug: accountSlug, page: { size: 500 } },
    { skip: !accountSlug }
  );
  const { data: currencies } = useListCurrencysForAccountQuery(
    { slug: accountSlug, page: { size: 500 } },
    { skip: !accountSlug }
  );

  const rates = buildPreferenceOptions(
    toRecords(rateTables?.data),
    currentRateTable
  );
  const money = buildPreferenceOptions(
    toRecords(currencies?.data),
    currentCurrency
  );

  const selected = (options, id: string | null) =>
    options.find((o) => o.value === (id || ACCOUNT_DEFAULT_VALUE));

  return (
    <>
      {rates.visible && (
        <Select2V2
          label="Preferred Rate Table"
          value={selected(rates.options, rateTableId)}
          options={rates.options}
          onChange={(e) => onRateTableChange(e.value || null)}
        />
      )}
      {money.visible && (
        <Select2V2
          label="Preferred Currency"
          value={selected(money.options, currencyId)}
          options={money.options}
          onChange={(e) => onCurrencyChange(e.value || null)}
        />
      )}
    </>
  );
};

export default PreferredDefaultsFields;
